import { render, staticRenderFns } from "./WorkIconNavNavision.vue?vue&type=template&id=c66d8472"
import script from "./WorkIconNavNavision.vue?vue&type=script&lang=js"
export * from "./WorkIconNavNavision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports